import { ModalMenuUI } from '@cube3/ui/src/Modal/ModalMenuUI';
import React, { useCallback } from 'react';
import { useModalActions } from '../../Modals/modalActions';
import { Button } from '@cube3/cubicle/src/core/atoms/Button';

const getProps = {
  YouTube: {
    channel: { id: 'youtube_channel_1', display_name: 'Channel 1' },
    categories: [
      { id: 'cat_1', display_name: 'cat 1' },
      { id: 'cat_2', display_name: 'cat 2' }
    ],
    exportTargetId: 'youtube_accout_1',
    exportTargetTypeId: 'Youtube',
    playlists: [
      { id: 'playlist_1', display_name: 'playlist 1' },
      { id: 'playlist_2', display_name: 'playlist 2' }
    ],
    platform: 'YouTube'
  },
  Meta: {
    adAccount: { id: 'meta_account', display_name: 'Meta account' },
    exportTargetId: 'meta_account',
    exportTargetTypeId: 'Meta',
    platform: 'Meta'
  },
  CM360: {
    profile: {
      id: 'cm360_profile',
      display_name: 'CM360 profile',
      advertisers: [
        {
          id: 'advertiser_1',
          display_name: 'Advertiser 1'
        },
        {
          id: 'advertiser_2',
          display_name: 'Advertiser 2'
        }
      ]
    },
    exportTargetId: 'cm360_acount',
    exportTargetTypeId: 'CM360',
    platform: 'CM360'
  },
  GoogleAds: {
    customer: [
      {
        id: 'customer_1',
        display_name: 'customer 1'
      },
      {
        id: 'customer_2',
        display_name: 'customer 2'
      }
    ],
    exportTargetId: 'google_ads_account',
    exportTargetTypeId: 'Google Ads',
    platform: 'Google Ads'
  },
  Contentful: {
    space: {
      id: 'contentful_space',
      display_name: 'space',
      environments: [
        {
          id: 'environment_1',
          display_name: 'environment 1'
        },
        {
          id: 'environment_2',
          display_name: 'environment 2'
        }
      ]
    },
    exportTargetId: 'contentful_account',
    exportTargetTypeId: 'Contentful',
    platform: 'Contentful'
  },
  TikTok: {
    creator_info: {
      display_name: 'tiktok creator',
      id: 'tiktok_creator_1',
      privacy_level_options: [],
      duet_disabled: false,
      comment_disabled: false,
      stich_disabled: false,
      max_video_post_duration: 5
    },
    exportTargetId: 'tiktok_creator_1',
    exportTargetTypeId: 'Tiktok',
    platform: 'TikTok'
  }
};

export const ExportsDebugModal = (props) => {
  const { platform } = props;

  const { previousModal, openModal } = useModalActions();

  const handleNext = useCallback(() => {
    openModal('social_export_options', getProps[platform], false);
  }, [platform]);

  return (
    <ModalMenuUI
      title="Export Debug modal"
      onCloseEvent={previousModal}
      wide={true}
      footerRightComponent={
        <>
          <Button
            label={'Cancel'}
            buttonStyle={'ghost'}
            onClick={previousModal}
            disabled={false}
          />
          <Button
            disabled={false}
            buttonStyle={'solid'}
            label={'Next'}
            onClick={handleNext}
          />
        </>
      }
    >
      {JSON.stringify(getProps[platform])}
    </ModalMenuUI>
  );
};
